import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '../ApiDocTable';
import SampleRequest from '../SampleRequest';
import { formatApiDocText } from '../../../utils/formatApiDocText';

const renderHttpRequest = (httpRequest) => {
	const match = httpRequest.match(/^(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS)\s+(.+)$/i);
	if (!match) {
		return httpRequest;
	}
	return (
		<>
			<span className='api-doc-http-method'>{match[1].toUpperCase()}</span> {match[2]}
		</>
	);
};

const ApiDocumentationContent = ({ content }) => {
	const { t } = useTranslation();
	return (
		<>
			<div className='mt-10 ml-3 mr-3 md:mr-0 md:ml-6'>
				<div className='border-b pb-12'>
					<div id={content.id}>
						{content.heading && (
							<h2 className='text-lg font-medium mb-4'>{t(content.heading)}</h2>
						)}

						{content.httpRequest && (
							<div className='api-doc-http-request w-full overflow-x-auto'>
								<div className='api-doc-http-request-inner'>
									<code>{renderHttpRequest(content.httpRequest)}</code>
								</div>
							</div>
						)}

						{content.description &&
							content.description.map((desc, descIndex) => (
								<p className='api-doc-description text-[#4C555A] text-[16px]' key={descIndex}>
									{formatApiDocText(t(desc))}
								</p>
							))}

						{content.list && (
							<ul className='list-disc'>
								{content.list.map((list, listIndex) => (
									<li key={listIndex}>{list}</li>
								))}
							</ul>
						)}

						{content.table && (
							<Table data={content.table?.data} column={content.table?.columns} />
						)}
					</div>
				</div>
				<div className='md:hidden'>
					<SampleRequest sampleObject={content.requestObject} />
				</div>
			</div>
		</>
	);
};

export default ApiDocumentationContent;
